import type { SliceComponentProps } from "@prismicio/react";
import { asText, asDate } from "@prismicio/helpers";
import { useLocale, useLocalePath } from "@commercekit/remix"
import React from "react";
import WvLink from "~/components/atoms/WvLink";
import { usePrismicLabels } from "~/hooks/usePrismicLabel";
import type { BlogContentAuthorSlice } from "~/lib/prismic/types.generated";

const BlogContentAuthor = ({
  slice,
}: SliceComponentProps<BlogContentAuthorSlice>) => {
  const { $pt } = usePrismicLabels();
  const localePath = useLocalePath();
  const { locale } = useLocale();

  return (
    <section className="col-12 news-item-footer mb-3 mb-lg-5 text-center text-sm-left">
      <p className="author mb-3 mb-sm-0" data-icon-before="">
        {$pt("blog_label_posted_by")} {asText(slice.primary.author_name)} {$pt("blog_label_posted_on")}
       {" "} {asDate(slice.primary.date_posted)?.toLocaleDateString(locale,  { day: "2-digit", month: 'long',  year: "numeric" })}
      </p>
      <p className="overview text-sm-right">
      <WvLink
          to={localePath("/blog/")}
          data-icon-before=""
        >
         {$pt("blog_label_back_to_home")}
        </WvLink>
      </p>
    </section>
  );
};
export default BlogContentAuthor;
